<template>
    <div class="DarkLayout">
        <div class="DarkLayout__header" v-if="!isMock">
            <DarkHeader />
        </div>
        <div :class="`DarkLayout__ctr ${!isFixed ? 'DarkLayout__ctr-auto' : ''} ${flex} ${isMock? 'DarkLayout__ctr-mock' : ''}`">
            <AppSide v-if="position === 'side'" />
            <AppSideLong v-else-if="position === 'side-long'" />
            <router-view v-else v-slot="{ Component }">
                <transition name="fade-transform" mode="out-in">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
        <ElDialog :model-value="isGongan" title="提示" width="30%" :show-close="false" :close-on-click-modal="false">
            <span>尚未开通公安考试功能</span>
        </ElDialog>
    </div>
</template>

<script setup>
import DarkHeader from '@/components/dark/DarkHeader.vue'
import { get } from 'lodash-es'
import AppSide from '@/components/home/AppSide.vue'
import AppSideLong from '@/components/home/AppSideLong.vue'
import { useStoreApp } from "@/store/app";
import { computed, onMounted, watch } from "vue";
import router from "@/router";
import { isMock } from "@/utils/util";
import useInit from "@/composerable/useInit";

const storeApp = useStoreApp();
const isGongan = computed(() => {
    return storeApp.isGongan !== 'Y' && (
        router.currentRoute.value.name !== 'home.system' && router.currentRoute.value.name !== 'my.password'
    )
})

const appStore = useStoreApp();

const topClass = computed(() => {
    return get(router.currentRoute.value.meta, 'topClass')
        ? 'DarkLayout__ctr-' + get(router.currentRoute.value.meta, 'topClass')
        : 'DarkLayout__ctr-default'
})
const flex = computed(() => {
    return get(router.currentRoute.value.meta, 'flex')
        ? 'DarkLayout__' + get(router.currentRoute.value.meta, 'flex')
        : ''
})

/**
 * 界面是固定的, 不随着宽度变化而变化
 * @type {ComputedRef<boolean>}
 */
const isFixed = computed(() => {
    return get(router.currentRoute.value.meta, 'layout') === 'fixed'
})
const position = computed(() => {
    return get(router.currentRoute.value.meta, 'position')
})

const calcAppClass = (route) => {
    let newVal = route;
    let app = document.getElementById('app')
    // 其他页面来到登录, 取消掉 handler , 取消掉定时
    if (newVal.name === 'my.data') {
        if (!app.classList.contains('app-data')) {
            app.classList.add('app-data')
        }
    }
    else {
        if (app.classList.contains('app-data')) {
            app.classList.remove('app-data')
        }
    }
    if (newVal.name === 'home.system') {
        if (!app.classList.contains('app-system')) {
            app.classList.add('app-system')
        }
    }
    else {
        if (app.classList.contains('app-system')) {
            app.classList.remove('app-system')
        }
    }
    if (newVal.name === 'suit.rank') {
        if (!app.classList.contains('app-rank')) {
            app.classList.add('app-rank')
        }
    }
    else {
        if (app.classList.contains('app-rank')) {
            app.classList.remove('app-rank')
        }
    }

    if (newVal.name === 'docs.detail') {
        if (!app.classList.contains('app-doc-detail')) {
            app.classList.add('app-doc-detail')
        }
    }
    else {
        if (app.classList.contains('app-doc-detail')) {
            app.classList.remove('app-doc-detail')
        }
    }
}

watch(() => router.currentRoute.value, (newVal) => {
    calcAppClass(newVal)
}, {
    deep: true
})

useInit();

onMounted(() => {
    calcAppClass(router.currentRoute.value)
})
</script>

<style lang="less">
#app {
    height: 100%; /*// 移除最小高 : 2022-08-29 , 首屏出现滚动条*/
    // min-height: calc(132px + 540px + 20px + 76px);overflow:hidden;font-size:14px;color:#fff;
    &.app-data {
        .DarkLayout {
            background: url('../assets/images/-data/bg.jpg') no-repeat top center;
            background-size: cover;
        }
    }

    &.app-rank {
        .DarkLayout {
            background: url('../assets/images/-layout/bg-rank.jpg') no-repeat top center;
            background-size: auto 100%;
        }
    }
    &.app-system {
        .DarkLayout {
            background: url('../assets/images/-layout/bg-system.jpg') no-repeat top center;
            background-size: cover;
        }
    }
    &.app-doc-detail {
        .DarkLayout__ctr {
            width: 1400px;
            overflow: inherit;
        }
    }
    .DarkLayout__ctr-mock{
        height: 100vh!important;
    }
    .DarkLayout__ctr {
        overflow-y: auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

@media screen and (max-height: 684px) {
    #app {
        .DarkLayout__ctr {
            max-height: calc(100vh - 84px);
            overflow-y: auto;
            display: block;
        }
    }
}
@media screen and (max-height: 914px) {
    #app.app-data {
        .DarkLayout__ctr {
            max-height: calc(100vh - 84px);
            overflow-y: auto;
            display: block;
        }
        .DarkLayout__ctr-mock{
            max-height: 100vh!important;
        }
    }
}

@media screen and (max-width: 1199px) {
    #app {
        .DarkLayout__ctr {
            max-height: calc(100vh - 84px);
            overflow-y: auto;
        }
        &.app-doc-detail {
            .DarkLayout__ctr {
                width: 100%;
            }
        }
    }
}
@media screen and (max-width: 1439px) {
    #app {
        &.app-data {
            .DarkLayout {
                .DarkLayout__ctr-default {
                    background: none;
                }
            }
        }
    }
}
</style>

